
import { useSelector }          from 'react-redux';
import translations             from "../../../config/localization";

const useTranslate = () => {
    const UIDisplayLanguage = useSelector( state => state.getIn([ 'ui', 'provider', 'UIDisplayLanguage' ]));

    return (key) => {
        return  (translations 
                && translations[UIDisplayLanguage] 
                && translations[UIDisplayLanguage][key])
                || key
    }
}

export default useTranslate;